import { render } from "./GalleryPage.vue?vue&type=template&id=5902fd06&scoped=true"
import script from "./GalleryPage.vue?vue&type=script&lang=js"
export * from "./GalleryPage.vue?vue&type=script&lang=js"

import "./GalleryPage.vue?vue&type=style&index=0&id=5902fd06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5902fd06"]])

export default __exports__